import { any } from 'prop-types';
import { Menu, Button, Dropdown } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

import { dataLayerHandleEvent } from 'utils/dataLayers';
import { ShareFacebookSVG, ShareTwitterSVG, SharePinterestSVG, ShareWhatsappSVG } from 'components/iconsSVG/social';
import { useI18n } from 'context/i18n';
import { IS_CAMPER } from 'utils/constants/system';

import styles from './style.module.css';

export function ProductShare({ baseUrl, code, image }) {
  const { t } = useI18n();
  const handleClickShareDropdown = () => {
    dataLayerHandleEvent({
      event: 'item_info',
      event_category: 'product detail',
      event_detail_1: 'share',
      event_detail_2: '',
    });
  };

  const handleDataShare = (event) => {
    dataLayerHandleEvent({
      event: 'share',
      event_category: 'social',
      event_detail_1: event.toLowerCase(),
      event_detail_2: '',
    });
  };

  const menu = () => {
    const href = baseUrl || '#';
    return (
      <Menu className={styles.shareMenu}>
        <Menu.Item key="share-facebook" className={styles.shareRow}>
          <a onClick={() => handleDataShare('Facebook')} href={`http://www.facebook.com/sharer.php?u=${href}`} target="_blank" rel="noreferrer">
            <ShareFacebookSVG />
          </a>
        </Menu.Item>
        <Menu.Item key="share-twitter" className={styles.shareRow}>
          <a onClick={() => handleDataShare('Twitter')} href={`http://twitter.com/intent/tweet?url=${href}`} target="_blank" rel="noreferrer">
            <ShareTwitterSVG />
          </a>
        </Menu.Item>
        <Menu.Item key="share-pinterest" className={styles.shareRow}>
          <a
            onClick={() => handleDataShare('Pinterest')}
            href={`http://pinterest.com/pin/create/button/?url=${href}&media=${image}`}
            target="_blank"
            rel="noreferrer"
          >
            <SharePinterestSVG />
          </a>
        </Menu.Item>
        <Menu.Item key="share-whatsapp" className={styles.shareRow}>
          <a onClick={() => handleDataShare('Whatsapp')} href={`https://api.whatsapp.com/send?text=${href}`} target="_blank" rel="noreferrer">
            <ShareWhatsappSVG />
          </a>
        </Menu.Item>
      </Menu>
    );
  };

  return IS_CAMPER ?
      <Dropdown overlay={menu} trigger={['click']} arrow placement="topLeft">
        <button onClick={handleClickShareDropdown} className={styles.shareTrigger}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
              stroke="#000"
              d="M4.5 6.5h15c.636 0 1.128.21 1.459.541.331.331.541.823.541 1.459V17.5c0 .636-.21 1.128-.541 1.459-.331.331-.823.541-1.459.541H4.5c-.636 0-1.128-.21-1.459-.541-.331-.331-.541-.823-.541-1.459V8.5c0-.636.21-1.128.541-1.459.331-.331.823-.541 1.459-.541ZM9.5 6v14M9.5 6l4 4.5M9.5 6l-4 4.5M6.625 3.008A248 248 0 0 0 8.848 5.5H5.5a1.5 1.5 0 1 1 1.125-2.492ZM12.375 3.008c-.647.733-1.544 1.746-2.223 2.492H13.5a1.5 1.5 0 1 0-1.125-2.492Z"
            />
          </svg>
          <span dangerouslySetInnerHTML={{ __html: t('ficha.producto', 'share') }} />
        </button>
      </Dropdown>
    : <Dropdown overlay={menu} trigger={['click']} arrow placement="topCenter">
        <Button onClick={handleClickShareDropdown} className={styles.shareTrigger}>
          <span dangerouslySetInnerHTML={{ __html: t('ficha.producto', 'share') }} /> <ArrowRightOutlined />
        </Button>
      </Dropdown>;
}

ProductShare.propTypes = {
  baseUrl: any,
  code: any,
  image: any,
};
